module.exports = __webpack_public_path__ + "img/563b48c.png";